import { useState, useCallback, useEffect, useRef } from 'react';
function matchQueries(query, size) {
    const params = {};
    const { width = 0, height = 0 } = size;
    for(const key in query){
        const { minWidth, maxWidth, minHeight, maxHeight, orientation } = query[key];
        const matchesWidth = (minWidth === undefined || width >= minWidth) && (maxWidth === undefined || width <= maxWidth);
        const matchesHeight = (minHeight === undefined || height >= minHeight) && (maxHeight === undefined || height <= maxHeight);
        const isPortrait = width < height;
        const matchesOrientation = orientation === undefined || (orientation === 'portrait' ? isPortrait : !isPortrait);
        params[key] = matchesWidth && matchesHeight && matchesOrientation;
    }
    return params;
}
function shallowEqual(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
/**
 * Tracks a container element's size and evaluates query conditions against it.
 *
 * @example
 * const query = {
 *     isNarrow: {maxWidth: 480},
 * }
 * const [{isNarrow}, ref] = useContainerQuery(query)
 */ export function useContainerQuery(query) {
    const q = query;
    const [params, setParams] = useState(()=>matchQueries(q, {}));
    const paramsRef = useRef(params);
    const [element, setElement] = useState(null);
    const refCallback = useCallback((node)=>{
        setElement(node);
    }, []);
    useEffect(()=>{
        if (!element) return;
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries){
                var _entry_borderBoxSize;
                const borderBox = (_entry_borderBoxSize = entry.borderBoxSize) === null || _entry_borderBoxSize === void 0 ? void 0 : _entry_borderBoxSize[0];
                const width = borderBox == undefined ? entry.contentRect.width : borderBox.inlineSize;
                const height = borderBox == undefined ? entry.contentRect.height : borderBox.blockSize;
                const next = matchQueries(q, {
                    width: width,
                    height: height
                });
                if (!shallowEqual(paramsRef.current, next)) {
                    paramsRef.current = next;
                    setParams(next);
                }
            }
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        JSON.stringify(q),
        element
    ]);
    return [
        params,
        refCallback
    ];
}
